import {
  GetterTree,
} from 'vuex';

import {
  SystemMessage,
} from '@/components/SystemMessages/types';
import {
  State,
} from '@/store/modules/system-messages/types';
import {
  RootState,
} from '@/store/types';

export const getters: GetterTree<State, RootState> = {
  list(state: State): SystemMessage[] {
    return state.list;
  },
};
